export default {"src":"/_next/static/media/no_match.2a1ccd05.svg","height":86,"width":86,"blurWidth":0,"blurHeight":0};